import styled from 'styled-components';

const HRSeparator = styled.hr`
  border: 1px solid var(--grey-3);
  margin: 40px 0;
  box-sizing: content-box;
  height: 0;
  overflow: visible;
  font-family: 'Sofia Pro';

  &:before {
    content: '${(props) => props.text}';
    text-align: center;
    left: 50%;
    top: 14px;
    padding: 0 15px 0 15px;
    transform: translate(-50%, -25px);
    display: inline-block;
    background-color: white;
    position: relative;
    margin: 0 auto;
    font-size: var(--font-size-20);
    color: var(--grey-8);
    font-weight: var(--font-weight-500);
  }
`;

export default HRSeparator;
